import axios from "axios";
import { API_BASE_URL } from "../constants";

const general_service_axios_back = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
});

function normalizeProductFilters(filters = {}) {
  const normalized = {};

  if (filters.brand_id !== undefined && filters.brand_id !== null) {
    const brandId = String(filters.brand_id).trim();
    if (brandId) {
      normalized.brand_id = brandId;
    }
  }

  if (filters.god_proizv !== undefined && filters.god_proizv !== null) {
    const year = String(filters.god_proizv).trim();
    if (year) {
      normalized.god_proizv = year;
    }
  }

  return normalized;
}

function buildProductsRequest(categoryID, filters = {}) {
  const normalizedFilters = normalizeProductFilters(filters);
  const params = new URLSearchParams(normalizedFilters);
  const query = params.toString();
  const url = `/api/get_products/${categoryID}/${query ? `?${query}` : ""}`;

  return {
    url,
  };
}

export class GeneralServiceBack {
  async getResourceBack(url) {
    try {
      const response = await general_service_axios_back.get(url);
      return response.data;
    } catch (error) {
      console.error(`API Error for ${url}:`, error);
      throw error;
    }
  }

  getAllCategoriesBack() {
    return this.getResourceBack("api/get_groups/");
  }

  async getProductsBack(categoryID, filters = {}) {
    const { url } = buildProductsRequest(categoryID, filters);

    try {
      const products = await this.getResourceBack(url);

      // Парсим gruppi_json_store и добавляем groupId к каждому продукту
      const enhancedProducts = this.enhanceProductsWithGroupIds(products);

      return enhancedProducts;
    } catch (error) {
      console.error(
        `Error loading products for category ${categoryID}:`,
        error,
      );
      throw error;
    }
  }

  getProductBack(product_id) {
    const url = "/api/get_product/" + product_id + "/";
    const initialRequest = typeof window === "undefined" ? null : window.__generalTrucksProductRequest;
    if (initialRequest) {
      // Consume once; a different product, subsequent navigation or retry needs fresh data.
      delete window.__generalTrucksProductRequest;
      if (initialRequest.url === url) {
        return initialRequest.promise.then(({ data, error }) => {
          if (error) throw error;
          return data;
        });
      }
    }
    return this.getResourceBack(url);
  }

  getProductsByFilterBack(filter) {
    return this.getResourceBack("/api/get_products/filter/" + filter + "/");
  }

  // Новый метод для получения всех продуктов одним запросом
  async getAllProductsBatch(groupIds, filters = {}) {
    const promises = groupIds.map((groupId) =>
      this.getProductsBack(groupId, filters),
    );

    try {
      const results = await Promise.allSettled(promises);
      const allProducts = results
        .filter((result) => result.status === "fulfilled")
        .flatMap((result) => result.value);

      return allProducts;
    } catch (error) {
      console.error("Error in batch products loading:", error);
      return [];
    }
  }

  // Улучшение продуктов с добавлением groupId
  enhanceProductsWithGroupIds(products) {
    return products.map((product) => {
      try {
        // Парсим gruppi_json_store и берем первый groupId как основной
        const groupIds = JSON.parse(product.gruppi_json_store || "[]");
        return {
          ...product,
          groupId: groupIds[0] || null, // Основной groupId
          allGroupIds: groupIds, // Все связанные groupIds
        };
      } catch (error) {
        console.error("Error parsing gruppi_json_store:", error);
        return {
          ...product,
          groupId: null,
          allGroupIds: [],
        };
      }
    });
  }

}
